<div class="content-wrapper" *ngIf="currentReport">
  <!-- Navbar -->
  <div class="controls-panel">
    <!-- Search by -->
    <input-search placeholder="Search by Changes Text" (searchTriggered)="searchChanged($event)" [provider]="reportHistoryProvider"
                  [no-drop-icon]="true" [parent-id]="currentReport.ID" style="width: 100%;"></input-search>

    <!-- Type -->
    <input-search placeholder="Select Module" [inputValue]="selectedModuleType" [preset]="moduleTypes" [regular]="true" (valueChange)="moduleChanged($event)"></input-search>

    <!-- Type -->
    <input-search placeholder="Select Type" [inputValue]="type" [preset]="historyTypes" [regular]="true" (valueChange)="typeChanged($event)"></input-search>

    <!-- Back to Summary -->
    <button class="btn btn-rbv" (click)="resetHistoryView()" *ngIf="dateFilter">
      <fa name="fa fa-angle-left"></fa>
      Back to Summary
    </button>
  </div>

  <!-- Loading -->
  <div class="spinner" *ngIf="isLoading">
    <div class="rect1"></div>
    <div class="rect2"></div>
    <div class="rect3"></div>
    <div class="rect4"></div>
    <div class="rect5"></div>
    <h6 class="text">Loading</h6>
  </div>

  <!-- List of history -->
  <ng-container *ngIf="summary?.length > 0 && history?.length === 0">
    <div class="summary-item" *ngFor="let sItem of summary; let i = index;" (click)="setDate(sItem.ITEM_DATE)">
      <!-- Date when Changed -->
      <div class="summary-item-date">
        <a>
          <fa name="fa fa-calendar-check-o"></fa>
          {{sItem.ITEM_DATE}}
        </a>
      </div>

      <!-- No. of changes -->
      <div class="summary-item-count">
        <span>{{sItem.ITEM_COUNT}}</span> changes
      </div>
    </div>
  </ng-container>

  <!-- No history found message -->
  <div class="no-items" *ngIf="(history.length === 0 && summary.length === 0 ) && !isLoading">
    no history for selected parameters
  </div>

  <!-- History -->
  <div class="change-items" *ngIf="history?.length > 0">
    <div class="change-item" *ngFor="let hItem of history; let i = index">
      <div class="item-header">
        <div class="item-field">
          {{hItem.FIELD_NAME | historyFieldName }}
        </div>

        <div class="item-info">
          {{hItem.DATE | date:'MM/dd/y HH:mm:ss'}} by {{hItem.USER ? (hItem.USER?.FIRST_NAME + ' ' + hItem.USER?.LAST_NAME) : 'System'}}
        </div>
      </div>

      <div class="row">
        <div class="col-6">
          <div class="item-info">
            Type: {{getTypeName(hItem.TYPE)}}
          </div>

          <div class="item-values" *ngIf="hItem.VALUE_PREV && hItem.TYPE !== HistoryType.DOCUMENT">
            Changed from <span class="value">{{hItem.VALUE_PREV}}</span> to <span class="value">{{hItem.VALUE_NEW}}</span>
          </div>

          <div class="item-values" *ngIf="!hItem.VALUE_PREV && hItem.TYPE !== HistoryType.DOCUMENT">
            Set to <span class="value">{{hItem.VALUE_NEW}}</span>
          </div>

          <div class="item-values" *ngIf="hItem.TYPE == HistoryType.DOCUMENT">
            Email sent <span class="value">{{hItem.VALUE_NEW}}</span>
          </div>
        </div>
        <div class="col-6 text-right">
            <!-- SHow History -->
          <button *ngIf="hItem?.TYPE ==  HistoryType.ASK_QUESTIONS " class="btn btn-rbv" (click)="showReportHistory(hItem?.ID)">View More</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Pagination -->
  <div style="width:100%;text-align:right;" *ngIf="totalItems > 20" class="pagination-wrapper">
    <pagination [totalItems]="totalItems" [itemsPerPage]="20" [(ngModel)]="currentPage" [maxSize]="5" [boundaryLinks]="true"
                [rotate]="false" (pageChanged)="pageChanged($event)" class="pagination-sm"></pagination>
  </div>
</div>
